import { FC } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Tooltip,
  Box,
} from '@chakra-ui/react';
import { useDetailStore } from 'page/MenuCategoryPage/hooks';
import { MenuCategoryNameInput } from '../../Forms';

type UseDetailStoreReturnType = ReturnType<typeof useDetailStore>;

type Props = UseDetailStoreReturnType['form'] &
  Pick<UseDetailStoreReturnType, 'values' | 'canDelete'> & {
    handleConfirm: () => void;
    handleDeleteConfirm: () => void;
  };

export const MenuCategoryEditInputModalView: FC<Props> = ({
  register,
  formState,
  values,
  handleConfirm,
  handleDeleteConfirm,
  canDelete,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">カテゴリーの更新</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>カテゴリーID</FormLabel>
          <Input
            type="text"
            value={values.id}
            width="240px"
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.name}>
          <FormLabel>カテゴリー名</FormLabel>
          <MenuCategoryNameInput name="name" register={register} />
          <FormErrorMessage>{formState.errors.name?.message}</FormErrorMessage>
        </FormControl>
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Stack alignItems="center" spacing="24px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          onClick={handleConfirm}
          isDisabled={!formState.isValid}
        >
          確認
        </Button>
        <Tooltip
          maxW="initial"
          label={
            canDelete ? '' : 'メニューが1つ以上含まれている為、削除できません'
          }
        >
          <Box>
            <Button
              variant="link"
              colorScheme="blackAlpha"
              onClick={handleDeleteConfirm}
              isDisabled={!canDelete}
            >
              このカテゴリーを削除
            </Button>
          </Box>
        </Tooltip>
      </Stack>
    </ModalFooter>
  </ModalContent>
);
